/**
 *
 * @module submitOrderRequest
 *
 */

import Check from 'check-types';
import Services from './../services/entry';
import PaymentInformation from './paymentInformation';
import LineItem from './lineItem';

const OrderCampaign = Services.Commerce.OrderCampaign;
const Locale = Services.Commerce.Locale;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    array,
    instanceStrict
} = Check.assert;

/**
 *
 * @class SubmitOrderRequest
 * @desc Information necessary to place an order.
 *
 */
export default class SubmitOrderRequest {

    /**
     *
     * @param {Array<SDK.Commerce.LineItem>} lineItems
     * @param {SDK.Commerce.PaymentInformation} paymentInformation
     * @param {SDK.Services.Commerce.OrderCampaign} orderCampaign
     * @param {SDK.Services.Commerce.Locale} locale
     * @throws {InvalidArgumentException}
     *
     */
    constructor(lineItems, paymentInformation, orderCampaign, locale) {

        const errorMessage = {
            ctor: 'SubmitOrderRequest(priceOrder, paymentInformation)',
            get lineItems() {
                return `${this.ctor} needs Array of SDK.Commerce.LineItem instance`;
            },
            get paymentInformation() {
                return `${this.ctor} needs SDK.Commerce.PaymentInformation instance`;
            },
            get orderCampaign() {
                return `${this.ctor} needs SDK.Services.Commerce.OrderCampaign instance`;
            },
            get locale() {
                return `${this.ctor} needs SDK.Services.Commerce.Locale instance`;
            }
        };

        array.of.instanceStrict(lineItems, LineItem, errorMessage.lineItems, InvalidArgumentException);
        instanceStrict(paymentInformation, PaymentInformation, errorMessage.paymentInformation, InvalidArgumentException); // eslint-disable-line
        instanceStrict(orderCampaign, OrderCampaign, errorMessage.orderCampaign, InvalidArgumentException);
        instanceStrict(locale, Locale, errorMessage.locale, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Array<SDK.Commerce.LineItem>}
         *
         */
        this.lineItems = lineItems;

        /**
         *
         * @access public
         * @type {SDK.Commerce.PaymentInformation}
         *
         */
        this.paymentInformation = paymentInformation;

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.OrderCampaign}
         *
         */
        this.orderCampaign = orderCampaign;

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.Locale}
         *
         */
        this.locale = locale;

    }

}



// WEBPACK FOOTER //
// ./src/commerce/submitOrderRequest.js